<div ng-if="!model.settingsVisible">
    <div class="widget-info-bar">
        <span ng-if="tasks.length > 0">
            <span>{{displayItemsText}}</span>
            &nbsp;&ndash;&nbsp;
        </span>
        <a ng-if="tasks.length > 0" ui-sref="{{model.sourceState}}">{{"workflowListLight.showList"|translate}}</a>
        <span ng-if="tasks.length == 0">{{"widget.empty.tasks"|translate}}</span>
    </div>
    <ul ng-if="tasks.length > 0" class="simple-list">
        <li ng-repeat="item in tasks">
            <c-list-item options="listOptions" render-item-as="template" item="item"></c-list-item>
        </li>
    </ul>
</div>
<div class="settingsContent properties" ng-show="model.settingsVisible">
    <div class="property-item">
        <label>{{"startPage.list.size" | translate}}</label>
        <div c-select options="lengths" selected-option="model.maxRows"></div>
    </div>
    <div class="property-item">
        <label>{{"startPage.sort.order" | translate}}</label>
        <div c-select options="sorts" selected-option="model.orderBy"></div>
    </div>
</div>